<div class="skeleton" [style.height]="height" [style.width]="width"></div>